import sgccApi from "@/api/sgccApi"
import useFunctions from '@/composables/useFunctions'

export const login = async ( { commit } , userData ) => {

    const { user, password, typeUser } = userData
    
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.post('/api/login', { user, password, typeUser })
        const { token: idToken, usuario: userResp } = data
        const { calculateExpirationTime } = useFunctions()
        const expirationTime = calculateExpirationTime();
        localStorage.setItem('currentRole', typeUser);
        
        commit('login', { userResp, idToken, expirationTime })
        
        return { ok: true, message: 'Usuario autenticado correctamente.' }

    } catch (error) {
        return { ok: false, message: error.response.data.message }
    }

}

export const refreshToken = async ({ commit }) => {
    const { checkTokenExpiration, calculateExpirationTime } = useFunctions()
    
    if (checkTokenExpiration()) {
        commit('logout')
        return { ok: false, message: 'SE HA CADUCADO LA SESIÓN' }
    }

    await sgccApi.get('/sanctum/csrf-cookie')
    const { data } = await sgccApi.post('/api/refresh');
    

    const { token: idToken, usuario: userResp } = data;
    const expirationTime = calculateExpirationTime();
    commit('login', { userResp, idToken, expirationTime })

    return { ok: true, message: 'TOKEN ACTUALIZADO CON ÉXITO' }
}

export const getUserWithToken = async ( { commit } ) => {

    try {

        
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.post('api/getUserWithToken')
        const { usuario: userResp } = data

        const expirationTime = localStorage.getItem('expirationTime');
        const idToken = localStorage.getItem('idToken');
        
        commit('login', { userResp, idToken, expirationTime })

        return { ok: true }

    } catch (error) {
        commit('logout')
        return { ok: false, message: error/* .response.data.error.message */ }
    }

}

export const logout = async ( { commit }) => {
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.post(`/api/logout`)
        if (data.ok) {
            commit('logout')
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}

export const changePassword = async ( _, { form }) => {
    const changePasswordForm = {
        currentPass: form.currentPass,
        password: form.password,
        password_confirmation: form.repeatPassword,
    }
    try {
        await sgccApi.get('/sanctum/csrf-cookie')
        const { data } = await sgccApi.post(`/api/clave`, changePasswordForm)
        if (data.ok) {
            return { ok: true, message: data.message }
        } else {
            return { ok: false, message: data.message }
        }
    } catch (error) {
        return { ok: false, message: error }
    }
}